<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.5 7.5L10.5 5.5H14C14.828 5.5 15.5 4.828 15.5 4V2C15.5 1.172 14.828 0.5 14 0.5H10C9.172 0.5 8.5 1.172 8.5 2V7.5Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.5 7.5H2C1.172 7.5 0.5 8.172 0.5 9V14C0.5 14.828 1.172 15.5 2 15.5H12C12.828 15.5 13.5 14.828 13.5 14V9C13.5 8.172 12.828 7.5 12 7.5H11.5"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M4.5 5.5V3.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M4.5 3.5C4.77614 3.5 5 3.27614 5 3C5 2.72386 4.77614 2.5 4.5 2.5C4.22386 2.5 4 2.72386 4 3C4 3.27614 4.22386 3.5 4.5 3.5Z"
      stroke="currentColor"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
    <path
      d="M4 12C4.55228 12 5 11.5523 5 11C5 10.4477 4.55228 10 4 10C3.44772 10 3 10.4477 3 11C3 11.5523 3.44772 12 4 12Z"
      fill="currentColor"
    />
    <path
      d="M10 12C10.5523 12 11 11.5523 11 11C11 10.4477 10.5523 10 10 10C9.44772 10 9 10.4477 9 11C9 11.5523 9.44772 12 10 12Z"
      fill="currentColor"
    />
  </svg>
</template>
